import axios from "axios";

// APIM path "invoices" is removed before the call reaches the API, so the controller route follows it,
// the same way as the other modules (/partners/Partner/...)
const baseUrl = `${process.env.REACT_APP_GITO_API_URL}/invoices/invoices`;

function headers(apiAccessToken) {
    return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
    };
}

export async function getHubInvoices(apiAccessToken) {
    const response = await axios.get(baseUrl, { headers: headers(apiAccessToken) });
    return response.data;
}

export async function getHubInvoice(invoiceId, apiAccessToken, requestStatus = true) {
    const response = await axios.get(`${baseUrl}/${invoiceId}`, {
        headers: headers(apiAccessToken),
        params: { requestStatus },
    });
    return response.data;
}

export async function deleteHubInvoice(invoiceId, apiAccessToken) {
    await axios.delete(`${baseUrl}/${invoiceId}`, { headers: headers(apiAccessToken) });
}

export async function sendHubInvoice(invoiceId, apiAccessToken) {
    await axios.post(`${baseUrl}/${invoiceId}/send`, null, { headers: headers(apiAccessToken) });
}

export async function sendHubInvoices(invoiceIds, apiAccessToken) {
    const response = await axios.post(`${baseUrl}/send`, { invoiceIds }, { headers: headers(apiAccessToken) });
    return response.data;
}

export async function generateCustomerInvoice(customerPublicId, apiAccessToken) {
    const response = await axios.post(`${baseUrl}/generate/customer`, null, {
        headers: headers(apiAccessToken),
        params: { customerPublicId },
    });
    return response.data;
}

export async function generatePartnerInvoice(partnerPublicId, year, month, apiAccessToken) {
    const response = await axios.post(`${baseUrl}/generate/partner`, null, {
        headers: headers(apiAccessToken),
        params: { partnerPublicId, year, month },
    });
    return response.data;
}

export async function getFreeInvoiceMonths(partnerPublicId, apiAccessToken) {
    const response = await axios.get(`${baseUrl}/generate/partner/months`, {
        headers: headers(apiAccessToken),
        params: { partnerPublicId },
    });
    return response.data;
}

export async function creditHubInvoice(invoiceId, apiAccessToken) {
    await axios.post(`${baseUrl}/${invoiceId}/credit`, null, { headers: headers(apiAccessToken) });
}

export async function checkHubInvoice(invoiceId, apiAccessToken) {
    await axios.post(`${baseUrl}/${invoiceId}/check`, null, { headers: headers(apiAccessToken) });
}

export async function addHubInvoiceLine(invoiceId, line, apiAccessToken) {
    await axios.post(`${baseUrl}/${invoiceId}/lines`, line, { headers: headers(apiAccessToken) });
}

export async function updateHubInvoiceLine(invoiceId, lineId, line, apiAccessToken) {
    await axios.put(`${baseUrl}/${invoiceId}/lines/${lineId}`, line, { headers: headers(apiAccessToken) });
}

export async function deleteHubInvoiceLine(invoiceId, lineId, apiAccessToken) {
    await axios.delete(`${baseUrl}/${invoiceId}/lines/${lineId}`, { headers: headers(apiAccessToken) });
}

export async function refreshHubInvoiceStatus(invoiceId, apiAccessToken) {
    await axios.post(`${baseUrl}/${invoiceId}/status-fetch`, null, { headers: headers(apiAccessToken) });
}

// The browser cannot read Content-Disposition here, so the name is built locally from the
// Swedish date the invoice was created, the same name the API gives: invoice_Gito_2026-11-02.pdf
function previewFileName(response, createdDate) {
    const type = response.headers["content-type"] || "";
    const extension = type.includes("spreadsheet") || type.includes("excel") || type.includes("sheet") ? "xlsx" : "pdf";
    return createdDate ? `invoice_Gito_${createdDate}.${extension}` : `invoice_Gito.${extension}`;
}

export async function openHubInvoicePreview(invoiceId, apiAccessToken, createdDate) {
    const response = await axios.get(`${baseUrl}/${invoiceId}/preview`, {
        headers: headers(apiAccessToken),
        responseType: "blob",
    });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = previewFileName(response, createdDate);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
